module.exports = __webpack_public_path__ + "static/media/stilly15.97761b98.JPG";